module.exports = __webpack_public_path__ + "img/wordmark-color.1331f141.png";